import { Box, Button, Checkbox, CircularProgress, FormControlLabel, FormGroup, Grid, TextField } from '@mui/material';
import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

import { api as stockApi } from '../store/domains/stock';

const MySwal = withReactContent(Swal);

const Notification = () => {
  const [file, setFile] = useState();
  const { data, isLoading } = stockApi.useGetDevices();
  const [sendNotification] = stockApi.usePostNotification();
  const { register, handleSubmit } = useForm();
  const [checkedItemsDealer, setCheckedItemsDealer] = useState({});
  const [checkedItemsDealerAndSubDealer, setCheckedItemsDealerAndSubDealer] = useState({});
  const handleCheckboxChange = (event, id, setStateFunction) => {
    setStateFunction((prev) => {
      const updatedItems = { ...prev };

      if (event.target.checked) {
        updatedItems[id] = true;
      } else {
        delete updatedItems[id];
      }

      return updatedItems;
    });
  };

  const handleChangeDealer = (event, id) => {
    handleCheckboxChange(event, id, setCheckedItemsDealer);
  };

  const handleChangeDealerAndSubdealer = (event, id) => {
    handleCheckboxChange(event, id, setCheckedItemsDealerAndSubDealer);
  };
  function handleChangeForm(event) {
    setFile(event.target.files[0]);
  }
  const onSubmit = async (data) => {
    let organizationIds;
    let organizationsType;

    if (Object.keys(checkedItemsDealer).length) {
      organizationIds = Object.keys(checkedItemsDealer);
      organizationsType = 1;
    } else if (Object.keys(checkedItemsDealerAndSubDealer).length) {
      organizationIds = Object.keys(checkedItemsDealerAndSubDealer);
      organizationsType = 2;
    }

    const form = new FormData();
    form.append('file', file);
    form.append(
      'notificationData',
      JSON.stringify({
        title: data.title,
        body: data.body,
        organizationIds,
      })
    );
    const formData = {
      form,
      organizationsType,
    };
    await sendNotification(formData).unwrap();
    MySwal.fire({
      title: <p>Notification will send.</p>,
      icon: 'success',
    });
  };

  if (isLoading) return <CircularProgress />;
  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Grid container spacing={2}>
        <Grid item xs={3} md={3}>
          Dealer
          <FormGroup>
            {data?.data?.map((item, index) => (
              <FormControlLabel
                control={
                  <Checkbox
                    disabled={!!Object.keys(checkedItemsDealerAndSubDealer).length}
                    checked={checkedItemsDealer[item.organizationId] || false}
                    onChange={(event) => handleChangeDealer(event, item.organizationId)}
                    inputProps={{ 'aria-label': `controlled-${item.organizationId}` }}
                  />
                }
                label={item.title}
                key={index}
              />
            ))}
          </FormGroup>
        </Grid>{' '}
        <Grid item xs={3} md={3}>
          Dealer and subdealer
          <FormGroup>
            {data?.data?.map((item, index) => (
              <FormControlLabel
                control={
                  <Checkbox
                    disabled={!!Object.keys(checkedItemsDealer).length}
                    checked={checkedItemsDealerAndSubDealer[item.organizationId] || false}
                    onChange={(event) => handleChangeDealerAndSubdealer(event, item.organizationId)}
                    inputProps={{ 'aria-label': `controlled-${item.organizationId}` }}
                  />
                }
                label={item.title}
                key={index}
              />
            ))}
          </FormGroup>
        </Grid>
        <Grid item xs={6} md={6}>
          <TextField
            label="Title"
            fullWidth
            variant="filled"
            {...register('title', {
              required: true,
            })}
          />
          <TextField
            fullWidth
            label="Body"
            multiline
            rows={4}
            variant="filled"
            sx={{ mt: 2 }}
            {...register('body', {
              required: true,
            })}
          />
          <Box display="flex" alignItems="center">
            <Button
              sx={{
                marginTop: 3,
              }}
              variant="contained"
              component="label"
            >
              Upload File
              <input onChange={handleChangeForm} type="file" hidden />
            </Button>
            {file && (
              <Box display="flex" alignItems="center" marginLeft={4}>
                {file.name}
                <CheckCircleOutlineIcon sx={{ marginLeft: 1 }} color="success" />
              </Box>
            )}
          </Box>
          <Button
            type="submit"
            variant="outlined"
            disabled={
              (!Object.keys(checkedItemsDealer).length && !Object.keys(checkedItemsDealerAndSubDealer).length) || !file
            }
            sx={{ mt: 2 }}
          >
            Submit
          </Button>
        </Grid>
      </Grid>
    </form>
  );
};
export default Notification;
